import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'

const gridFiltersConfig: any = {
    FIBUNR: { prop: null, param: 'FIBUNR', url_param: false },
    GUELTIGKEIT: { prop: null, param: 'GUELTIGKEIT', url_param: false },
    GUELTIGZUM: { prop: null, param: 'GUELTIGZUM', url_param: false },
    FILTEREBANKING: { prop: null, param: 'FILTEREBANKING', url_param: false },
}

const initialState = {
    loadIx2044ListStatus: 'idle',
    loadIx2044ListError: undefined as any,
    loadIx2044ListLastArgs: undefined as any,
    load2044Status: 'idle',
    load2044Error: undefined as any,
    save2044Status: 'idle',
    save2044Error: undefined as any,
    update2044Status: 'idle',
    update2044Error: undefined as any,
    process2048Status: 'idle',
    process2048Error: undefined as any,

    ix2044List: [] as any[],
    currentRechnungeingangsbuch: undefined as any,
    processedRechnungeingangsbuch: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadIx2044List = createAsyncThunk('ix2044Slice/loadIx2044List', async ({ gridFilters, ixCommonRuntime, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().ix2044Slice.loadIx2044ListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, ixCommonRuntime }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/xsp_2044/?HdrId=0&GueltugZumDatum=${gridFilters.values.GUELTIGZUM || ''}&FibuNr=${gridFilters.lookupValues.FIBUNR?.OBJNR || 0}&ObjNr=0&Wjahr=${ixCommonRuntime.year}&FilterEbanking=${gridFilters.values.FILTEREBANKING}`, undefined, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, ixCommonRuntime }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadIx2044ListStatus } = getState().ix2044Slice
        return loadIx2044ListStatus !== 'pending'
    }
})

export const load2044 = createAsyncThunk('ix2044Slice/load2044', async ({ selectedItem }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/CIxReBuchScrnVarsRebuIdToJson/?RebuId=${selectedItem.REBUCHID}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { load2044Status } = getState().ix2044Slice
        return load2044Status !== 'pending'
    }
})

export const save2044 = createAsyncThunk('ix2044Slice/save2044', async ({ ix2044 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/CIxReBuchScrnVarsSaveBuvorgangRebuFromJson/`,
        prepareData({ data: ix2044 }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { save2044Status } = getState().ix2044Slice
        return save2044Status !== 'pending'
    }
})

export const update2044 = createAsyncThunk('ix2044Slice/update2044', async ({ ix2044 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/CIxReBuchScrnVarsSaveBuvorgangRebuFromJson/`,
        prepareData({ data: ix2044 }),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { update2044Status } = getState().ix2044Slice
        return update2044Status !== 'pending'
    }
})

export const process2048 = createAsyncThunk('ix2044Slice/process2048', async ({ data }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.put(
        `/api/ixweb/CIxReBuchScrnVarsProcessBuvorgangRebuFromJson/`,
        prepareData(data),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { process2048Status } = getState().ix2044Slice
        return process2048Status !== 'pending'
    }
})

const Ix2044Slice = createSlice({
    name: 'ix2044Slice',
    initialState,
    reducers: {
        resetloadIx2044ListError: (state) => {
            state.loadIx2044ListError = undefined
        },
        resetload2044: (state) => {
            state.currentRechnungeingangsbuch = undefined
            state.load2044Error = undefined
        },
        resetload2044Error: (state) => {
            state.load2044Error = undefined
        },
        resetsave2044: (state) => {
            state.currentRechnungeingangsbuch = undefined
            state.save2044Error = undefined
        },
        resetsave2044Error: (state) => {
            state.save2044Error = undefined
        },
        resetupdate2044: (state) => {
            state.currentRechnungeingangsbuch = undefined
            state.update2044Error = undefined
        },
        resetupdate2044Error: (state) => {
            state.update2044Error = undefined
        },
        resetprocess2048: (state) => {
            state.processedRechnungeingangsbuch = undefined
            state.process2048Error = undefined
        },
        resetprocess2048Error: (state) => {
            state.process2048Error = undefined
        },
        removeFromIx2044ListById: (state, action) => {
            state.ix2044List = state.ix2044List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromIx2044ListByIds: (state, action) => {
            state.ix2044List = state.ix2044List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.ix2044List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadIx2044ListStatus = 'preloaded'
            state.loadIx2044ListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.ix2044List = []
            state.loadIx2044ListStatus = 'idle'
            state.loadIx2044ListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadIx2044List.pending, (state) => {
            state.loadIx2044ListStatus = 'pending'
            state.loadIx2044ListError = undefined
        })
        builder.addCase(loadIx2044List.fulfilled, (state, action) => {
            state.loadIx2044ListStatus = 'idle'

            if (!action.payload) { return }

            state.loadIx2044ListLastArgs = action.payload.args

            {
                state.ix2044List = action.payload.data

            }
        })
        builder.addCase(loadIx2044List.rejected, (state, action) => {
            state.loadIx2044ListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadIx2044ListError = action.error.message
            } else {
                state.loadIx2044ListError = action.payload
            }
        })

        builder.addCase(load2044.pending, (state) => {
            state.load2044Status = 'pending'
            state.load2044Error = undefined
        })
        builder.addCase(load2044.fulfilled, (state, action) => {
            state.load2044Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentRechnungeingangsbuch = newItem
            }
        })
        builder.addCase(load2044.rejected, (state, action) => {
            state.load2044Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.load2044Error = action.error.message
            } else {
                state.load2044Error = action.payload
            }
        })

        builder.addCase(save2044.pending, (state) => {
            state.save2044Status = 'pending'
            state.save2044Error = undefined
        })
        builder.addCase(save2044.fulfilled, (state, action) => {
            state.save2044Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentRechnungeingangsbuch = newItem
            }
        })
        builder.addCase(save2044.rejected, (state, action) => {
            state.save2044Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.save2044Error = action.error.message
            } else {
                state.save2044Error = action.payload
            }
        })

        builder.addCase(update2044.pending, (state) => {
            state.update2044Status = 'pending'
            state.update2044Error = undefined
        })
        builder.addCase(update2044.fulfilled, (state, action) => {
            state.update2044Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.currentRechnungeingangsbuch = newItem
            }
        })
        builder.addCase(update2044.rejected, (state, action) => {
            state.update2044Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.update2044Error = action.error.message
            } else {
                state.update2044Error = action.payload
            }
        })

        builder.addCase(process2048.pending, (state) => {
            state.process2048Status = 'pending'
            state.process2048Error = undefined
        })
        builder.addCase(process2048.fulfilled, (state, action) => {
            state.process2048Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.processedRechnungeingangsbuch = newItem
            }
        })
        builder.addCase(process2048.rejected, (state, action) => {
            state.process2048Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.process2048Error = action.error.message
            } else {
                state.process2048Error = action.payload
            }
        })

    }
})

export const {
    resetloadIx2044ListError,
    resetload2044,
    resetload2044Error,
    resetsave2044,
    resetsave2044Error,
    resetupdate2044,
    resetupdate2044Error,
    resetprocess2048,
    resetprocess2048Error,
    removeFromIx2044ListById,
    removeFromIx2044ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Ix2044Slice.actions
export default Ix2044Slice.reducer
